import { useBrandAndCountry } from 'src/modules/hooks/useBrandAndCountry';
import { useDispatch, useSelector } from 'src/store/react';
import { selectLanguage, selectZone } from 'src/store/selectors';
import { getQuickSearchLinks } from '../utils/getQuickSearchLinks';

export const useQuickSearch = () => {
  const dispatch = useDispatch();
  const { country } = useBrandAndCountry();
  const languageCode = useSelector(selectLanguage);
  const zone = useSelector(selectZone);

  const links = getQuickSearchLinks(zone, languageCode);

  return {
    dispatch,
    country,
    languageCode,
    zone,
    links,
  };
};
